module.exports = __webpack_public_path__ + "img/covve-logo.2d215c86.svg";